import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { ElLoading } from 'element-plus';
import { transformStr3, handleHttp, getformListItemsdata, getformListItemsdatas, insertStr } from "@/utils/utils";
import 'ol/ol.css';
import { Map, View } from 'ol';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import SourceImagestatic from 'ol/source/ImageStatic';
import LayerImage from 'ol/layer/Image';
import XYZ from 'ol/source/XYZ';
import { defaults } from 'ol/control';
import Attribution from 'ol/control/Attribution';
import { transformExtent, fromLonLat, transform, toLonLat } from 'ol/proj';
import Projection from 'ol/proj/Projection';
import Point from 'ol/geom/Point';
import Style from 'ol/style/Style';
import StyleIcon from 'ol/style/Icon';
import StyleText from 'ol/style/Text';
import StyleFill from 'ol/style/Fill';
import StyleStroke from 'ol/style/Stroke';
import Feature from 'ol/Feature';
import { GeoJSON } from 'ol/format';
import DragPan from 'ol/interaction/DragPan';
import MouseWheelZoom from 'ol/interaction/MouseWheelZoom';
import DoubleClickZoom from 'ol/interaction/DoubleClickZoom';
import PinchRotate from 'ol/interaction/PinchRotate';
import Overlay from 'ol/Overlay';
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import { BMapLoader } from '@/utils/bdMap.js';
import VueAudio from 'vue-audio';
// import 'vue-audio-player/dist/vueaudioplayer.css'
import maptype from '@/view/map/hdmconfig/type';
import maplist from '@/view/map/hdmconfig/list';
import { getPan, getPinchRotate, getdragPan } from '@/view/map/js/common';
import mappopup from '@/components/map/popup/index';
export default {
  name: 'assembly',
  meta: {
    title: '地图'
  },
  props: ['id', 'mapconfigdatas', 'mapconfigData', 'type'],
  components: {
    VueAudio,
    maptype,
    maplist,
    mappopup
  },
  data() {
    return {
      bodywidth: 0,
      isIpad: false,
      isApp: false,
      fid: this.$route.query.fid,
      formUserId: this.$route.query.formUserId,
      mapconfigData: {
        mapbg: '',
        logo: '',
        type: '',
        staticImg: ''
      },
      mapconfigform: {
        formId: '177623',
        pageSize: 1
      },
      currentformuser: {},
      mapcfData: '',
      map: null,
      mapconfig: {
        mapMinZoom: 10,
        mapMaxZoom: 13,
        center: [],
        extent: [],
        currentZoom: 10
      },
      mapcontainer: '',
      iconLayer: '',
      iconSource: '',
      imageLayer: '',
      wmsLayer: '',
      detail: '',
      // 定点详情对象
      swiperEl: '',
      // 弹窗轮播图ref
      typeList: [],
      // 分类列表
      currentType: 0,
      // 分类默认当前索引
      modeltype: 1,
      // 弹窗默认模板样式
      typemodel: 1,
      // 弹窗默认模板样式
      customtypemodel: false,
      dotimgW: 100,
      // 定点图片默认宽度
      popshowflag: false,
      // 控制弹窗显隐
      listyleobj: {},
      // 分类默认样式对象
      listobjon: {},
      // 分类选中样式对象
      zoom: 0,
      mtObj: {
        title_font: 'bold 14px 微软雅黑',
        title_color: 'rgba(255,255,255,1)',
        title_bgcolor: 'rgba(0, 0, 255, 0.7)',
        title_bocolor: '',
        offsetX: 0,
        offsetY: 32,
        padding: [2, 10, 1, 10]
      },
      mapdataform: {
        formId: '165054',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      // 搜索定位点字段
      searchStr: {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': '40',
            'compt': 'editinput',
            'express': '===',
            'val': ''
          }]
        }, {
          "model": 1,
          "filters": []
        }]
      },
      datatimer: null,
      jsonOption: {},
      defaultIcon: require('../../../assets/map/icon_address_red.png'),
      typeshow: true
    };
  },
  mounted() {
    this.bodywidth = document.body.clientWidth;
    let userAgent = navigator.userAgent;
    this.isIpad = /macintosh|mac os x/i.test(userAgent) && !userAgent.match(/(iPhone\sOS)\s([\d_]+)/) || userAgent.match(/(iPad).*OS\s([\d_]+)/);
    if (document.body.clientWidth < 926) this.isApp = true;
    let that = this;
    this.$nextTick(() => {
      that.initMap();
    });
  },
  methods: {
    initMap(id) {
      // console.log(this.iconSource)
      // 清空mapcontent内的元素
      let mapcontent = document.querySelector(`#map${id || this.id}`);
      if (mapcontent && mapcontent.childNodes.length > 0) {
        mapcontent.removeChild(mapcontent.childNodes[0]);
      }
      this.zoom = 0;
      this.map = null;
      let datatimer = null;
      datatimer = setInterval(() => {
        if (this.mapconfigdatas && this.mapconfigdatas.onlyid) {
          clearInterval(datatimer);
          let data = this.mapconfigdatas;
          this.formatData(data);
          if (data.mapmodetype === '切片地图') this.Tilemap();
          if (data.mapmodetype === '静态地图') this.staticmap(data);
          // 获取地图配置项后 取当前层级渲染
          let isHastype = false;
          this.searchStr.filters.forEach(item => {
            if (item.filters.length > 0) {
              item.filters.forEach(child => {
                if (child.alias === '40') child.val = data['46'] || data['title'];
                if (child.alias === 'map_type') isHastype = true;
              });
            }
          });
          // 筛选条件添加type选项
          if (this.type !== '' && !isHastype) {
            this.searchStr.filters.push({
              "model": 0,
              "filters": [{
                'alias': 'map_type',
                'compt': 'editinput',
                'express': '===',
                'val': this.type
              }]
            });
          }
          this.mapdataform.searchStr = encodeURI(JSON.stringify(this.searchStr));
        }
      }, 50);
    },
    formatData(data) {
      // console.log(_this.mapconfigdatas)
      document.title = data.toptitle = '' ? '地图' : data.toptitle;
      this.mapconfig.extent = data.transformExtent.split(',');
      this.mapconfig.extent.forEach((item, index) => {
        this.mapconfig.extent[index] = Number(this.mapconfig.extent[index]);
      });
      let modeltypeval = data.modeltype;
      // console.log(modeltypeval)
      this.modeltype = parseInt(modeltypeval.charAt(modeltypeval.length - 1));
      if (data.textbg) this.colorConfig(data.textbg, '--hand-drawn-pop-textbg');
      if (data.colorTheme1) this.colorConfig(data.colorTheme1, '--hand-drawn-pop-colortheme1');
      if (data.colorTheme2) this.colorConfig(data.colorTheme2, '--hand-drawn-pop-colortheme2');
      if (this.modeltype === 3) {
        if (data.colorTheme1) {
          this.colorConfig(data.colorTheme1, '--hand-drawn-pop-colortheme07', 0.7);
          this.colorConfig(data.colorTheme1, '--hand-drawn-pop-colortheme01', 0.1);
        }
      }
      if (data.mapmodetype === '切片地图') {
        this.mapconfig.mapMinZoom = Number(data.mapMinLevel);
        this.mapconfig.mapMaxZoom = Number(data.mapMaxLevel);
      }
      if (data.mapmodetype === '静态地图') {
        this.mapconfig.mapMinZoom = Number(data.staticMapMinLevel);
        this.mapconfig.mapMaxZoom = Number(data.staticMapMaxLevel);
        this.mapconfigData.staticImg = handleHttp(data.staticImg);
      }
      if (document.body.clientWidth < 768) {
        this.mapconfigData.mapbg = handleHttp(data.appBgImg);
        this.dotimgW = data.appimgW;
        this.mapconfig.currentZoom = Number(data.appCurrentLevel);
        this.mapconfig.center = data.appMapCenter.split(',');
        this.mapconfig.center.forEach((item, index) => {
          this.mapconfig.center[index] = Number(this.mapconfig.center[index]);
        });
      } else {
        this.mapconfigData.mapbg = handleHttp(data.backgroundImg);
        this.dotimgW = data.dotimgW;
        this.mapconfig.currentZoom = Number(data.currentLevel);
        this.mapconfig.center = data.mapCenter.split(',');
        this.mapconfig.center.forEach((item, index) => {
          this.mapconfig.center[index] = Number(this.mapconfig.center[index]);
        });
      }
      this.listyleobj.width = data.typewidth + 'px';
      this.listyleobj.height = data.typeheight + 'px';
      this.listyleobj.lineHeight = data.typeheight + 'px';
      this.listyleobj.color = data.typecolor;
      if (data.typebg !== '') this.listyleobj.background = 'url(' + data.typebg + ') center center 100% no-repeat';
      this.listobjon.width = data.typewidth + 'px';
      this.listobjon.height = data.typeheight + 'px';
      this.listobjon.lineHeight = data.typeheight + 'px';
      this.listobjon.color = data.typefocuscolor + '!important';
      if (data.typefocusbg !== '') {
        this.listobjon.background = 'url(' + data.typefocusbg + ') no-repeat!important';
        this.listobjon.backgroundSize = '100% 100%!important';
        this.listobjon.backgroundPosition = 'center!important';
      }
      let typeform = '';
      if (data.jsontxt && data.jsontxt !== '') {
        this.jsonOption = JSON.parse(this.getStr(data.jsontxt));
        // console.log(this.jsonOption)
        if (this.jsonOption.point) {
          Object.keys(this.jsonOption.point).forEach(item => {
            this.mtObj[item] = this.jsonOption.point[item];
          });
        }
        if (this.jsonOption.type) {
          typeform = this.jsonOption.type;
          this.typemodel = this.jsonOption.type.model.replace('模板', '');
          if (this.jsonOption.type.typeflag === '否') this.typeshow = false;
        }
        if (this.jsonOption.footerinfo) {
          data.footerinfo = this.jsonOption.footerinfo;
          this.viewCount = parseInt(this.jsonOption.footerinfo.viewCount) + parseInt(this.jsonOption.footerinfo.viewplus);
          // 记录浏览量
          // this.setViewCount(this.viewCount)
        }
        this.getformstruct(typeform);
      }
    },
    // 获取表单字段结构 属性 分类数据
    getformstruct(val) {
      let params = {
        deptId: this.fid,
        formId: '260297',
        page: 1,
        limit: 100,
        searchStr: {
          filters: [{
            alias: "onlyid",
            compt: "editinput",
            express: '===',
            val: this.mapconfigdatas.onlyid
          }],
          model: 0
        },
        orderBy: val !== '' && val.orderBy !== '' ? val.orderBy : 'manualOrderTop,manualOrder',
        orderType: val !== '' && val.orderType !== '' ? val.orderType : ''
      };
      params.searchStr = encodeURI(JSON.stringify(params.searchStr));
      this.$api.singleadvanceSearch(params).then(res => {
        if (res.dataList.length > 0) {
          this.typeList = [];
          res.dataList.map(item => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            this.typeList.push({
              title: item.itemformdata.title || item.itemformdata[1],
              value: item.itemformdata.title || item.itemformdata[1],
              formUserId: item.id,
              formId: item.formId,
              disabled: true,
              icon: itemformat.icon && itemformat.icon.length > 0 ? itemformat.icon[0].fileUrl : '',
              id: item.itemformdata[2]
            });
            return item;
          });
          console.log(this.typeList);
          this.$emit('typeList', this.typeList);
          // this.typeList.unshift({title: '全部'})
        }
      });
    },
    // 筛选类型
    typeselect(data) {
      console.log(data);
      if (data.typemodel && data.typemodel.flag) {
        this.customtypemodel = true;
        this.modeltype = data.typemodel.model;
      }
      let val = data.item;
      let index = data.index;
      this.detail = '';
      let typesearchflag = false;
      if (val.value === '全部') {
        this.searchStr.filters.forEach((item, index) => {
          if (item.filters[0].alias === 'map_type') this.searchStr.filters.splice(index, 1);
        });
        this.currentType = 0;
      } else {
        this.searchStr.filters.forEach(item => {
          if (item.filters[0].alias === 'map_type') {
            item.filters[0].val = val.value;
            typesearchflag = true;
          }
        });
        if (!typesearchflag) {
          this.searchStr.filters.push({
            "model": 0,
            "filters": [{
              'alias': 'map_type',
              'compt': 'editinput',
              'express': '===',
              'val': val.title
            }]
          });
        }
        this.currentType = index + 1;
      }
      this.mapdataform.searchStr = encodeURI(JSON.stringify(this.searchStr));
      this.iconSource.clear();
      this.mapdataform.page = 1;
      this.getmapdataform();
    },
    // 静态地图
    staticmap(data) {
      this.mapcontainer = this.$refs[`map${this.id}`];
      let extent = this.mapconfig.extent;
      let projection = new Projection({
        projection: 'EPSG:4326',
        code: 'xkcd-image',
        units: 'pixels',
        extent: extent
      });
      this.imageLayer = new LayerImage({
        source: new SourceImagestatic({
          url: this.handleHttp(this.mapconfigData.staticImg),
          //这里添加静态图片的地址
          projection: projection,
          imageExtent: extent
        })
      });
      this.iconSource = new VectorSource();
      this.iconLayer = new VectorLayer({
        source: this.iconSource
      });
      this.map = new Map({
        controls: defaults({
          attribution: false
        }),
        layers: [this.imageLayer, this.iconLayer],
        target: this.mapcontainer,
        view: new View({
          projection: projection,
          center: this.mapconfig.center,
          zoom: this.mapconfig.currentZoom,
          minZoom: this.mapconfig.mapMinZoom,
          maxZoom: this.mapconfig.mapMaxZoom
        })
      });
      this.mapLoadEnd(data);
    },
    mapLoadEnd(data) {
      this.map.on('singleclick', this.singleclick);
      this.map.on('click', this.markerclick);
      this.map.on('pointermove', this.markermove);
      let that = this;
      // 缩放地图 结束后事件
      this.map.on('moveend', function (event) {
        that.resolutionchange(event);
      });
    },
    // 获取当前 地图位置
    singleclick(val) {
      let coordinateArr = transform(val.coordinate, 'EPSG:3857', 'EPSG:4326');
      console.log("coordinate: " + coordinateArr[0].toFixed(6) + "," + coordinateArr[1].toFixed(6));
    },
    // 点击当前 定位点 详情
    markerclick(evt, type) {
      console.log(evt);
      let feature = '';
      if (evt.id) {
        feature = evt;
      } else {
        feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
          return feature;
        });
      }
      this.overlay = undefined;
      this.popshowflag = false;
      if (feature) {
        console.log(this.popshowflag);
        let featureId = feature.id ? feature.id : feature.get('id');
        // console.log(featureId)
        let _this = this;
        this.$api.singleformUserId(this.fid, this.mapdataform.formId, featureId).then(res => {
          let detaildata = res.formUserList[0].formData;
          let deatilObj = {
            currentShowtype: 'banner'
          };
          detaildata.forEach(item => {
            deatilObj[transformStr3(item.alias)] = _this.getformitemdata(item);
          });
          // console.log(deatilObj)
          deatilObj.audio = deatilObj.audio !== '' ? deatilObj.audio.map(item => {
            item.title = item.name.replace(`.${item.suffix}`, '');
            this.$api.getUrlByObjectId(item.objectId).then(res => {
              let currenthttp = location.protocol;
              item.url = res.http;
            });
            return item;
          }) : '';
          deatilObj.video = deatilObj.video !== '' ? deatilObj.video.map(item => {
            item.title = item.name.replace(`.${item.suffix}`, '');
            this.$api.getUrlByObjectId(item.objectId).then(res => {
              let currenthttp = location.protocol;
              item.url = res.http;
            });
            return item;
          }) : '';
          if (deatilObj.video.length > 0) {
            let videoTimer = setTimeout(() => {
              if (deatilObj.video[0].url !== undefined) {
                clearTimeout(videoTimer);
                deatilObj.cVideourl = deatilObj.video[0].url;
                deatilObj.cVideotitle = deatilObj.video[0].title;
              }
            }, 500);
            // console.log(_this.currentVideo)
          }
          this.detail = deatilObj;
          if (this.customtypemodel) {
            this.$emit('detail', this.detail);
            // return false
          }
          console.log(this.typemodel);

          // 外链是否打开新窗口字段判断
          if (deatilObj['44'] !== '') {
            if (this.detail.linkTarget !== undefined && this.detail.linkTarget === '是') {
              window.open(decodeURIComponent(deatilObj['44']));
              return;
            }
            // location.href = decodeURIComponent(deatilObj['44'])
            window.open(decodeURIComponent(deatilObj['44']));
          } else {
            if (deatilObj['42'] === '') return;
            if (deatilObj['42'] === '链接' && deatilObj['44'] === '') return;
            if (deatilObj['42'] === '仅展示') return;
            // 珠海点击弹窗 使用overlay方式 可跟随点
            this.popshowflag = true;
          }
          // console.log(this.detail)
        });
      }
    },
    // 地图实时放大缩小事件
    resolutionchange(event) {
      let zoom = Math.round(event.map.getView().getZoom());
      if (this.zoom === zoom) return;
      this.zoom = zoom;
      let minZoom = this.mapconfig.mapMinZoom;
      let orData = [];
      for (let i = minZoom; i <= zoom; i++) {
        orData.push({
          'alias': 'map_level',
          'compt': 'editinput',
          'express': '===',
          'val': i
        });
      }
      this.searchStr.filters.forEach(item => {
        if (item.model === 1) item.filters = orData;
      });
      this.mapdataform.searchStr = encodeURI(JSON.stringify(this.searchStr));
      // console.log(this.mapdataform.searchStr)
      this.iconSource.clear();
      this.mapdataform.page = 1;
      this.getmapdataform();
    },
    setViewCount(val) {
      let num = val + 1;
      let formData = {
        deptId: this.$route.query.fid,
        formId: this.currentformuser.formId,
        formUserId: this.formUserId || this.$route.query.formUserId
      };
      // console.log(this.jsonOption)
      this.jsonOption.footerinfo.viewCount = num;
      let dataList = [{
        'alias': 'onlyid',
        'compt': 'autonumber',
        'values': [{
          'val': this.mapconfigdatas.onlyid
        }]
      }, {
        'alias': 'title',
        'compt': 'editinput',
        'values': [{
          'val': this.mapconfigdatas.title
        }]
      }, {
        'alias': 'jsontxt',
        'compt': 'richtext',
        'values': [{
          'val': '<p element-id=\"init\" style="display: none;">' + JSON.stringify(this.jsonOption) + '</p>'
        }]
      }];
      this.$api.editForm(formData.deptId, formData.formUserId, encodeURI(JSON.stringify(dataList)), formData.formId).then(res => {});
    },
    // 获取地图点数据
    getmapdataform() {
      let that = this;
      this.mapdataform.deptId = this.fid;

      // this.loading = ElLoading.service({
      //   lock: true,
      //   text: '数据加载中',
      //   background: 'rgba(0, 0, 0, 0.7)',
      // })
      this.$api.singleadvanceSearch(this.mapdataform).then(res => {
        // console.log(res)
        if (res.dataList.length > 0) {
          if (res.totalPage === 1) {
            that.iconSource.clear();
            that.dataformat(res);
            // that.loading.close()
          } else {
            if (that.mapdataform.page === 1) {
              that.iconSource.clear();
              that.dataformat(res);
            } else {
              that.dataformat(res);
            }
            that.mapdataform.page++;
            if (res.totalPage >= that.mapdataform.page) that.getmapdataform();
            // if (res.totalPage === that.mapdataform.page) that.loading.close()
          }
        } else {
          // that.loading.close()
        }
      }).catch(e => {
        console.log(e);
      });
    },
    dataformat(res) {
      res.dataList.forEach((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
        });
        item.itemformdata = itemformat;
        if (itemformat.pca !== undefined && itemformat.pca.toString() !== '') {
          let areaArr = itemformat.pca.split('|')[1];
          item.itemformdata.area = areaArr.split(',')[2];
        }
        this.createPoint(itemformat, item);
      });
      if (this.mapdataform.page === 1) {
        this.dataList = res.dataList.filter(item => {
          return item.itemformdata['42'] !== '仅展示';
        });
      } else {
        this.dataList.concat(res.dataList.filter(item => {
          return item.itemformdata['42'] !== '仅展示';
        }));
      }
    },
    createPoint(itemformat, item) {
      // console.log(this.jsonOption)
      // console.log(itemformat)
      let _this = this;
      let zoom = Math.round(this.map.getView().getZoom());
      let zoomdifference = Number(zoom) - Number(this.mapconfig.currentZoom);
      // console.log(itemformat)
      if (itemformat['34'] === '隐藏') return false;
      if (!itemformat.mapCoordinates) return;
      let c = itemformat['mapCoordinates'].split(',');
      let cX = Number(c[0]);
      let cY = Number(c[1]);
      let imgtextFeature = new Feature({
        geometry: new Point(fromLonLat([cX, cY])),
        id: item.id,
        name: itemformat['placeName'],
        xy: [cX, cY]
      });
      // 处理点位文字
      let textstyle = '';
      if (this.mapconfigdatas['locationTitle'] === '显示' || itemformat.showplaceName === '是') {
        let setOffset = [0, 32];
        if (itemformat['titleoffset'] && itemformat['titleoffset'].toString() !== '' && !itemformat.titleoffset.includes('NaN')) {
          setOffset = itemformat['titleoffset'].replace(/，/, ',').split(',');
        }
        let stroke = this.mtObj.title_bocolor;
        let placename = itemformat['placeName'];
        if (placename.length > 10) {
          placename = insertStr(placename, 10, ',');
        }
        textstyle = new StyleText({
          text: placename.includes(',') ? placename.split(',').join('\n') : placename,
          font: this.mtObj.title_font,
          fill: new StyleFill({
            color: this.mtObj.title_color
          }),
          offsetX: setOffset[0],
          offsetY: itemformat.show4 === '否' ? 0 : zoomdifference > 1 ? zoomdifference * 5 + Number(setOffset[1]) : Number(setOffset[1]),
          backgroundFill: new StyleFill({
            color: this.mtObj.title_bgcolor
          }),
          stroke: stroke !== '' ? new StyleStroke({
            color: stroke,
            width: 2
          }) : '',
          padding: [2, 10, 0, 10]
        });
      }
      // console.log(this.jsonOption.point)
      if (this.jsonOption.point && this.jsonOption.point.location_title && this.jsonOption.point.location_title !== '显示') textstyle = '';
      // 处理点位图片
      let ispointImg = this.jsonOption.point && this.jsonOption.point.pointImg && this.jsonOption.point.pointImg !== '是';
      let imageicon = itemformat[4].length === 0 ? '' : ispointImg ? '' : new StyleIcon({
        radius: 4,
        src: handleHttp(itemformat[4][0].fileUrl),
        offset: [0, 0],
        width: 100
      });
      imgtextFeature.setStyle(new Style({
        image: itemformat.show4 === '否' ? '' : imageicon,
        text: itemformat.showplaceName === '否' ? '' : textstyle
      }));
      let iconstyle = imgtextFeature.getStyle();
      if (iconstyle.getText()) {
        let textscale = zoomdifference > 1 ? zoomdifference * 0.1 + 1 : 1;
        iconstyle.getText().setScale(textscale);
      }
      // 处理点位图片宽度自适应地图
      if (itemformat.show4 !== '否' && imageicon !== '') {
        let img = new Image();
        img.src = iconstyle.image_.iconImage_.src_;
        img.onload = function () {
          let width = img.width;
          // 以宽度为100为例
          let imgmultiple = (itemformat.picwidth !== undefined && itemformat.picwidth.length !== 0 ? parseInt(itemformat.picwidth) : _this.dotimgW) / width;
          let scale = zoomdifference > 1 ? imgmultiple * (zoomdifference - 0.5) : imgmultiple;
          iconstyle.getImage().setScale(imgmultiple);
          imgtextFeature.setStyle(iconstyle);
          _this.iconSource.addFeature(imgtextFeature);
        };
      } else {
        imgtextFeature.setStyle(iconstyle);
        this.iconSource.addFeature(imgtextFeature);
      }
      // 处理点位图标
      if (this.jsonOption.point && this.jsonOption.point.pointIcon && this.jsonOption.point.pointIcon === '是') {
        let iconFeature = new Feature({
          geometry: new Point(fromLonLat([cX, cY])),
          id: `${item.id}`,
          name: itemformat.placeName,
          xy: [cX, cY],
          image: itemformat[4].length === 0 ? '' : handleHttp(itemformat[4][0].fileUrl),
          picwidth: itemformat.picwidth
        });
        let icon = itemformat.mapType === '' ? this.defaultIcon : this.getTypeIcon(itemformat['43']);
        if (icon !== '') {
          iconFeature.setStyle(new Style({
            image: new StyleIcon({
              radius: 4,
              src: icon,
              offset: [0, 0],
              width: 28
            })
          }));
          this.iconSource.addFeature(iconFeature);
        }
      }
    },
    getTypeIcon(id) {
      let icon = this.defaultIcon;
      this.typeList.forEach(elem => {
        if (Number(elem.id) === Number(id)) {
          if (elem.icon && elem.icon !== '') icon = elem.icon;
        }
      });
      return icon;
    },
    // 处理表单数据
    getformitemdata(data) {
      let typekey = 'val';
      if (!data.values) return '';
      if (data.compt === 'videobox' || data.compt === 'fileupload' || data.compt === 'imagebox' || data.compt === 'location' || data.compt === 'selectmultibox') return data.values.length ? data.values : '';
      return data.values.length && data.values[0] ? data.values[0][typekey] : '';
    },
    // 处理请求协议
    handleHttp(val) {
      let currenthttp = location.protocol;
      if (val !== undefined) {
        if (currenthttp === 'https:') {
          return val.replace('http:', currenthttp);
        } else {
          return val;
        }
      }
    },
    // 鼠标移入显示
    markermove(evt) {
      let allfeatures = this.iconSource.getFeatures();
      allfeatures.forEach(item => {
        if (item.get('hover')) {
          this.iconSource.removeFeature(item);
        }
      });
      let feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        return feature;
      });
      if (feature) {
        let featureName = feature.get('name');
        let featureCenter = feature.get('xy');
        let featureId = feature.get('id');
        let featureImage = feature.get('image');
        let picwidth = feature.get('picwidth');
        this.hoverId = featureId;
        if (!featureCenter) return;
        if (this.jsonOption.point && this.jsonOption.point.location_title === '2') {
          const yvalue = 0.0006 / (this.zoom * (this.zoom + 1));
          let x = featureCenter[0];
          let y = featureCenter[1] + yvalue;
          let textFeature = new Feature({
            geometry: new Point(fromLonLat([x, y])),
            id: `hover${featureId}`,
            name: featureName,
            hover: true
          });
          let stroke = this.mtObj.title_bocolor;
          textFeature.setStyle(new Style({
            text: new StyleText({
              text: featureName,
              font: this.mtObj.title_font,
              fill: new StyleFill({
                // 可以在此处设置字体样式，与css同
                color: this.mtObj.title_color
              }),
              offsetX: this.mtObj.offsetX,
              offsetY: 0,
              backgroundFill: new StyleFill({
                color: this.mtObj.title_bgcolor
              }),
              stroke: stroke !== '' ? new StyleStroke({
                color: stroke,
                width: 2
              }) : '',
              padding: this.mtObj.padding
            })
          }));
          this.iconSource.addFeature(textFeature);
        }
        if (this.jsonOption.point && this.jsonOption.point.pointImg === '2') {
          if (!featureImage) return;
          const yvalue = 0.0015 / (this.zoom * 2);
          let x = featureCenter[0];
          let y = featureCenter[1] + yvalue;
          let imgFeature = new Feature({
            geometry: new Point(fromLonLat([x, y])),
            id: `hover${featureId}`,
            name: featureName,
            hover: true
          });
          imgFeature.setStyle(new Style({
            image: new StyleIcon({
              src: featureImage
            })
          }));
          // this.iconSource.addFeature(imgFeature)
          let that = this;
          let imgstyle = imgFeature.getStyle();
          let img = new Image();
          img.src = imgstyle.image_.iconImage_.src_;
          img.onload = function () {
            let width = img.width;
            // 以宽度为100为例
            let imgmultiple = that.isApp ? that.mapconfigdatas.appimgW / width : (picwidth !== undefined && picwidth.length !== 0 ? parseInt(picwidth) : that.mapconfigdatas.dotimgW) / width;
            imgstyle.getImage().setScale(1);
            imgFeature.setStyle(imgstyle);
            // console.log(that)
            that.iconSource.addFeature(imgFeature);
          };
        }
      }
    },
    getformitemsdata(data) {
      let typekey = 'val';
      if (!data.values) return '';
      if (data.compt === 'imagebox') typekey = 'fileUrl';
      return data.values.length && data.values[0] ? data.values[0][typekey] : '';
    },
    getStr(str) {
      return str.replace(/(<\/?p.*?>)/gi, '');
    },
    // 弹窗关闭事件
    closeHandle() {
      this.detail = '';
      this.popshowflag = false;
      this.$emit('closeHandle');
    },
    // 处理颜色
    colorConfig(data, name, alpha) {
      // console.log(name)
      if (alpha !== undefined) {
        document.documentElement.style.setProperty(name, `rgba(${this.set16ToRgb(data)}, ${alpha})`);
      } else {
        let themecolor = '';
        if (data.includes('#')) themecolor = data;
        document.documentElement.style.setProperty(name, themecolor);
      }
    },
    // 返回首页
    gobackright() {
      // console.log(this.mapconfig.center)
      let center = this.mapconfigdatas.mapmodetype === '切片地图' ? fromLonLat(this.mapconfig.center) : this.mapconfig.center;
      this.map.getView().animate({
        zoom: this.mapconfig.currentZoom,
        center: center,
        rotation: 0,
        duration: 1000
      });
      this.iconSource.clear();
      this.mapdataform.page = 1;
      this.getmapdataform();
    },
    set16ToRgb(str) {
      var reg = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;
      if (!reg.test(str)) {
        return;
      }
      let newStr = str.toLowerCase().replace(/\#/g, '');
      let len = newStr.length;
      if (len == 3) {
        let t = '';
        for (var i = 0; i < len; i++) {
          t += newStr.slice(i, i + 1).concat(newStr.slice(i, i + 1));
        }
        newStr = t;
      }
      let arr = []; //将字符串分隔，两个两个的分隔
      for (var i = 0; i < 6; i = i + 2) {
        let s = newStr.slice(i, i + 2);
        arr.push(parseInt("0x" + s));
      }
      return arr.join(",");
    }
  }
};